<p *ngIf="showLabel">
  <span translationEditableDirective="PROCESSED">{{
    'PROCESSED' | translate
  }}</span>
  {{ current }}
  <span translationEditableDirective="OF">{{ 'OF' | translate }}</span>
  {{ total }}
</p>
<div class="progress" [ngClass]="{ 'has-error': error }">
  <span [style.width.%]="(current / total) * 100 || 0">
    <small>{{ ((current / total) * 100 || 0).toFixed(1) }}%</small>
  </span>
</div>
